import styled from 'styled-components';

export const StepGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px;
`;

export const FormatGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 12px;
`;

interface SelectableProps {
  $active: boolean;
  $accent?: string;
}

export const PlatformCard = styled.button<SelectableProps>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 10px;
  text-align: left;
  background: #ffffff;
  border: 1px solid ${({ $active, $accent }) => ($active ? $accent ?? '#0b4f9e' : '#e4e4e7')};
  box-shadow: ${({ $active }) => ($active ? '0 6px 18px rgba(15, 23, 42, 0.1)' : 'none')};
  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;

  &:hover {
    border-color: ${({ $accent }) => $accent ?? '#0b4f9e'};
    transform: translateY(-1px);
  }
`;

export const PlatformIcon = styled.span<{ $accent: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  flex: none;
  color: #ffffff;
  background: ${({ $accent }) => $accent};
`;

export const CardTitle = styled.span`
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #18181b;
  line-height: 1.3;
`;

export const CardHint = styled.span`
  display: block;
  font-size: 12px;
  color: #71717a;
  line-height: 1.4;
`;

export const FormatCard = styled.button<SelectableProps>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px;
  border-radius: 10px;
  background: #ffffff;
  border: 1px solid ${({ $active }) => ($active ? '#0b4f9e' : '#e4e4e7')};
  box-shadow: ${({ $active }) => ($active ? '0 6px 18px rgba(15, 23, 42, 0.1)' : 'none')};
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    border-color: #0b4f9e;
  }
`;

export const FormatPreviewArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 96px;
  border-radius: 8px;
  background: #f4f4f5;
`;

export const FormatPreview = styled.div<{ $ratio: number; $accent: string }>`
  height: ${({ $ratio }) => ($ratio >= 1 ? 'auto' : '78px')};
  width: ${({ $ratio }) => ($ratio >= 1 ? '120px' : 'auto')};
  aspect-ratio: ${({ $ratio }) => $ratio};
  max-height: 78px;
  max-width: 120px;
  border-radius: 4px;
  background: ${({ $accent }) => $accent};
  opacity: 0.85;
`;

export const StepHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 12px;
`;

export const StepLabel = styled.span`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #0b4f9e;
`;

export const StepHeading = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #18181b;
`;

export const StepDescription = styled.p`
  font-size: 13px;
  color: #71717a;
`;

export const CreativeGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
  gap: 14px;
`;

export const CreativeCard = styled.article`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid #e4e4e7;
  background: #ffffff;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    border-color: #0b4f9e;
    box-shadow: 0 6px 18px rgba(15, 23, 42, 0.08);
  }
`;

export const CreativePreview = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 132px;
  border-radius: 8px;
  background: #f4f4f5;
  overflow: hidden;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`;

export const CreativeActions = styled.div`
  display: flex;
  gap: 6px;
  margin-top: auto;
`;

export const FilterRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-bottom: 16px;
`;
